<template>
<div class="page">
    <div class="loading-screen" v-if="status=='LOADING'">
        <div>
            <span class="spinner spinner--lg"></span>
            <span>loading assessments…</span>
        </div>
    </div>

    <div v-if="status=='LOADED'">
        <ExamineeNavBar />
        <div class="container">
            <div class="page-head rise">
                <h1>Your Assessments</h1>
                <p>Timed coding assessments assigned to you. Live ones can be started right away.</p>
            </div>

            <div v-if="(assesments.length == 0 || assesments.reduce((acc, cur) => acc && isEnded(cur),true))"
                 class="glass empty-state rise rise-1">
                <div class="empty-state__icon">🗓️</div>
                <h2>No live exams today</h2>
                <p>Nothing scheduled right now — but you can try the sample assessment anytime.</p>
                <a class="btn btn--primary" :href="`/${sampleExam._id}/questions`">Take the Sample Exam →</a>
            </div>

            <div v-else>
                <div class="glass card mb-3 rise flex justify-between items-center flex-wrap gap-3" style="border-style:dashed">
                    <div>
                        <h2 class="card__title">🧪 Practice anytime</h2>
                        <p class="text-dim" style="font-size:0.9rem">Warm up with the untimed sample assessment before your real exam.</p>
                    </div>
                    <a class="btn btn--ghost btn--sm" :href="`/${sampleExam._id}/questions`">Take the Sample Exam →</a>
                </div>
                <div v-for="(assesment, idx) in assesments" :key="assesment._id">
                    <div v-if="!isEnded(assesment)" class="glass card card--hover mb-3 rise" :class="`rise-${Math.min(idx+1,4)}`">
                        <div class="flex justify-between items-center flex-wrap gap-3">
                            <div>
                                <span class="card__meta">assessment {{String(assesments.indexOf(assesment)+1).padStart(2,'0')}}</span>
                                <h2 class="card__title mt-2">{{assesment.name}}</h2>
                                <div class="flex gap-2 flex-wrap mt-2">
                                    <span class="chip">📅 {{assesment.date.date}}/{{assesment.date.month}}/{{assesment.date.year}}</span>
                                    <span class="chip">🕐 {{pad(assesment.startTime.hours)}}:{{pad(assesment.startTime.minutes)}} — {{pad(assesment.endTime.hours)}}:{{pad(assesment.endTime.minutes)}}</span>
                                </div>
                            </div>
                            <div style="text-align:right">
                                <div v-if="!isStarted(assesment)">
                                    <span class="status-pill status-pill--soon">starts soon</span>
                                </div>
                                <div v-else-if="isStarted(assesment) && !isEnded(assesment)">
                                    <span class="status-pill status-pill--live">live</span>
                                    <div class="countdown mt-2">
                                        ends in {{(getRemainingHours(assesment))<10?'0'+(getRemainingHours(assesment)):(getRemainingHours(assesment))}}:{{(getRemainingMinutes(assesment)-1)<10?'0'+(getRemainingMinutes(assesment)-1):(getRemainingMinutes(assesment))-1}}:{{(60-currentTimeSeconds)<10?'0'+(60-currentTimeSeconds):(60-currentTimeSeconds)}}
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <a v-if="isStarted(assesment) && !isEnded(assesment)"
                                       class="btn btn--primary btn--sm" :href="`/${assesment._id}/questions`">
                                       Start Assessment →
                                    </a>
                                    <span v-else class="btn btn--ghost btn--sm" style="opacity:0.5;cursor:not-allowed">
                                       Start Assessment →
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {getSampleAssesment, getAssesments} from '../services/assesments'
import ExamineeNavBar from './ExamineeNavBar.vue';
export default {
    name: "AssesmentsPage",
    data() {
        return {
            status: "LOADING",
            error: "",
            assesments: this.getTodayassesments(),
            currentDateAndTime: this.getTodayDate(),
            currentDate: null,
            currentTime: null,
            isLoaded: null,
            examCount : 0,
            sampleExam : {}
        };
    },
    methods: {
        pad(n) {
            return n > 9 ? '' + n : '0' + n;
        },
        async getTodayassesments() {
            this.status='LOADING';
            try {
                const response = await getAssesments(this.$store.state.auth.userId);
                this.assesments = response.data.filter(assesment => assesment.name!='Sample Exam');
                const response1 = await getSampleAssesment();
                this.sampleExam = response1.data;
                this.status = 'LOADED';
            }
            catch (error) {
                this.status = 'ERROR';
                this.error = error.message;
            }

        },
        isStarted(assesment) {
            let assesmentStartTime = new Date(assesment.date.year,assesment.date.month-1,assesment.date.date,assesment.startTime.hours,assesment.startTime.minutes);
           return this.currentDateAndTime >= assesmentStartTime;
        },
        isEnded(assesment){
            let assesmentEndTime = new Date(assesment.date.year,assesment.date.month-1,assesment.date.date,assesment.endTime.hours,assesment.endTime.minutes);
            return this.currentDateAndTime > assesmentEndTime;
        },
        getTodayDate(){
            let date = new Date();
            return date;
        },
        getCurrentdateAndTime(){
            let date = new Date();
            this.currentDateAndTime = date;
            this.currentDate = date.toLocaleDateString();
            this.currentTime = date.toLocaleTimeString();
        },
        getRemainingMinutes(assesment) {
            let minutes = assesment.endTime.minutes-this.currentTimeMinutes;
            return minutes>0?minutes:60+minutes;
        },
        getRemainingHours(assesment) {
            let minutes = assesment.endTime.minutes-this.currentTimeMinutes;
            return minutes>0?assesment.endTime.hours-this.currentTimeHour:assesment.endTime.hours-this.currentTimeHour-1;
        }
    },
    computed: {
        currentTimeHour() {
             return this.currentDateAndTime.getHours();
        },
        currentTimeMinutes() {
             return this.currentDateAndTime.getMinutes();
        },
        currentTimeSeconds() {
            return this.currentDateAndTime.getSeconds();
        },

    },
    components: { ExamineeNavBar},
    mounted () {
         setInterval(() => {
            this.getCurrentdateAndTime();
        },1000)
    }
}
</script>
